import { createFileRoute } from '@tanstack/react-router';
import { PlatformAdminsTable } from '../../pages/platform/admins/PlatformAdminsTable';

// Administradores a nivel PLATAFORMA (`/platform/users`). Hereda el guard de scope PLATFORM del layout
// padre (_layout.platform). El gate fino del item de menú + acciones usa los permisos `platform.user.*`.
export const Route = createFileRoute('/_authenticated/_layout/platform/admins')({
    component: () => <PlatformAdminsTable />,
});
